import { render, staticRenderFns } from "./CommonBtn.vue?vue&type=template&id=3b6490e8&scoped=true"
import script from "./CommonBtn.vue?vue&type=script&lang=js"
export * from "./CommonBtn.vue?vue&type=script&lang=js"
import style0 from "./CommonBtn.vue?vue&type=style&index=0&id=3b6490e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6490e8",
  null
  
)

export default component.exports